import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=01a4d8b6&scoped=true&"
import script from "./CategorySlider.vue?vue&type=script&lang=js&"
export * from "./CategorySlider.vue?vue&type=script&lang=js&"
import style0 from "./CategorySlider.vue?vue&type=style&index=0&id=01a4d8b6&prod&lang=css&"
import style1 from "./CategorySlider.vue?vue&type=style&index=1&id=01a4d8b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4d8b6",
  null
  
)

export default component.exports